import React from 'react';
import NavbarLayout from '@theme/Navbar/Layout';
import NavbarContent from '@theme/Navbar/Content';

import DocsSubnav from '@site/src/components/DocsSubnav';

export default function Navbar(): React.ReactElement {
  return (
    <NavbarLayout>
      <NavbarContent />
      <DocsSubnav />
    </NavbarLayout>
  );
}
